import CTAButton from "../CTAButton";
import theme from "../../Styles/theme.scss";
import React from "react";

type InstallationNextButtonProps = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  isDesktop?: boolean;
  textColor?: string;
  marginRight?: string;
  marginLeft?: string;
  marginTop?: string;
  marginBottom?: string;
  cypresstestid?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
}

const InstallationNextButton = ({
  icon,
  label,
  onClick,
  disabled,
  type,
  cypresstestid,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
}: InstallationNextButtonProps) => {
  return (
    <CTAButton
      style={{
        width: "100%",
        padding: "12px",
        backgroundColor: disabled && theme.neutral2,
        display: "flex",
        borderRadius: "8px",
        color: `${theme.neutral7}`,
        marginTop: marginTop || "",
        marginBottom: marginBottom || "",
        marginLeft: marginLeft || "",
        marginRight: marginRight || "",
        // handle mobile fontWeight
      }}
      onClick={onClick}
      disabled={disabled}
      type={type}
      cypresstestid={cypresstestid}
    >
      {icon && icon}
      {label || "Next"}
    </CTAButton>
  );
};

export default InstallationNextButton;
